import React from 'react'
import Link from 'gatsby-link'

import Sectiontitle from '../components/sectionTitle'

import '../sass/partials/activityblock.scss'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight } from '@fortawesome/fontawesome-free-solid'

class ActivityMap extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return ( 
            <div className="activity-map">
                <div className="activity-map--block">
                    <Sectiontitle title="and the learning continues..." color="yellow" />
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Visits to local libraries
                    </div>
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Reading favourite books
                    </div>
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Learning about numbers
                    </div>
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Learning to write the alphabet
                    </div>
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Learning about different words &amp; sounds
                    </div>
                    <div className="activity-map--desc rc-copy small">
                        <FontAwesomeIcon icon={faArrowAltCircleRight} /> 
                        Trips to local shops
                    </div>
                </div>
            </div>
        );
    }
}

export default ActivityMap



// WEBPACK FOOTER //
// ./src/components/activityMap.js